export const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
] as const;

export const ALLOWED_EXTENSIONS = ["jpeg", "jpg", "png", "pdf"] as const;

// Image MIME types specifically
export const IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
] as const;

export const IMAGE_EXTENSIONS = ["jpeg", "jpg", "png"] as const;

// File input accept attribute value
export const FILE_INPUT_ACCEPT = ".jpeg,.jpg,.png,.pdf,image/jpeg,image/jpg,image/png,application/pdf";

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 10MB

export const a11yProps = (index: number) => ({
  id: `applicant-tab-${index}`,
  "aria-controls": `applicant-tabpanel-${index}`,
});

